import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ILead, ILeadReq } from "../../models/BaseModel";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { pdf, PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import InvoiceDocument from "../../shared/InvoicePdf";
import { ConfirmDialog } from "primereact/confirmdialog";
import { generateInvoiceHtml } from "../../shared/InvoiceHtml";
import { generateItineraryHTML } from "../../shared/generateItineraryText";
import NewItineraryDocument from "../../shared/NewItineraryPdf";

interface Iprops {
    singleData: ILead,
    open: boolean,
    hideDialog: () => void
    toast: any
}

export const Itinerary = (props: Iprops) => {
    const [isInvoice, setIsInvoice] = useState(false);
    const [leadReqs, setLeadReq] = useState<ILeadReq[]>();
    const [confirmVisible, setConfirmVisible] = useState(false);
    const [sending, setSending] = useState(false);

    useEffect(() => {
        if (props.singleData.id) {
            console.log("Loading lead requirements for lead ID:", props.singleData.id);
            loadLeadRequirement(props.singleData.id);
        }
    }, [props.singleData]);

    const loadLeadRequirement = async (leadId: number) => {
        const response = await Fetch(`leadreq/${leadId}`, "GET", null, null, props.toast);
        if (response) {
            const reqs: ILeadReq[] = await response.json();
            const _reqs = reqs.map(req => {
                req.checkin = new Date(req.checkin || new Date());
                req.checkout = new Date(req.checkout || new Date());

                if (req.pickAndDrops) {
                    req.pickAndDrops = req.pickAndDrops
                        .map(p => ({ ...p, time: p.time ? new Date(p.time) : undefined }))
                        .sort((a, b) => {
                            const timeA = a.time?.getTime() ?? 0;
                            const timeB = b.time?.getTime() ?? 0;
                            return timeA - timeB;
                        });
                }
                return req;
            });
            setLeadReq(_reqs);
        }
    }

    const onHide = () => {
        props.hideDialog();
        setLeadReq(undefined);
    }

    const rejectFunc = () => {
        props.toast.current.show({ severity: "error", detail: "You have Canceled", life: 3000 })

    }

    const confirmDelete = () => {
        setConfirmVisible(true);
    };

    // const sendItineraryEmail = async () => {
    //     if (!leadReq) return;

    //     const documentComponent = isInvoice
    //         ? <InvoiceDocument lead={props.singleData} req={leadReq} />
    //         : <ItineraryDocument lead={props.singleData} req={leadReq} />;

    //     // Generate PDF as blob
    //     const blob = await pdf(documentComponent).toBlob();

    //     // Prepare form data
    //     const formData = new FormData();
    //     formData.append('subject', isInvoice ? `Invoice for ${props.singleData.contactName}` : `Itinerary for ${props.singleData.contactName}`);
    //     formData.append('body', `Please find the ${isInvoice ? 'invoice' : 'itinerary'} attached.`);
    //     formData.append('ids', JSON.stringify([props.singleData.id])); // send to this contact
    //     formData.append('attachments', new File([blob], `${isInvoice ? 'Invoice' : 'Itinerary'}_${props.singleData.contactName}.pdf`));

    //     try {
    //         const response = await Fetch('leadreq/senditerinary', 'POST', formData, null, props.toast);
    //         if (response) {
    //             console.log(1)
    //             props.toast.show({ severity: 'success', summary: 'Email Sent', detail: 'The document has been sent successfully.' });
    //         } else {
    //             props.toast.show({ severity: 'error', summary: 'Failed', detail: 'Unable to send the email.' });
    //         }
    //     } catch (error) {
    //         console.error(error);
    //         props.toast.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong while sending email.' });
    //     }
    // }


    const sendItineraryEmail = async (): Promise<boolean> => {
        if (!leadReqs) return false;

        const documentComponent = isInvoice
            ? <InvoiceDocument lead={props.singleData} reqs={leadReqs} />
            : <NewItineraryDocument lead={props.singleData} reqs={leadReqs} />;

        const blob = await pdf(documentComponent).toBlob();

        const emailBody = isInvoice
            ? generateInvoiceHtml(props.singleData, leadReqs[0])
            : generateItineraryHTML(props.singleData, leadReqs[0]);

        const formData = new FormData();
        formData.append('subject', isInvoice ? `Invoice for ${props.singleData.contactName}` : `Itinerary for ${props.singleData.contactName}`);
        formData.append('body', emailBody);
        formData.append('ids', JSON.stringify([props.singleData.contactId]));
        formData.append('attachments', new File([blob], `${isInvoice ? 'Invoice' : 'Itinerary'}_${props.singleData.contactName}.pdf`));

        try {
            const response = await Fetch('leadreq/senditerinary', 'POST', formData, null, props.toast);
            if (response) {
                props.toast.current?.show({ severity: 'success', summary: 'Email Sent', detail: 'Email Sent Successfully.', });
                return true;
            } else {
                props.toast.current?.show({
                    severity: 'error',
                    summary: 'Failed',
                    detail: 'No valid email addresses found.',
                });
                return false;
            }
        } catch (error) {
            console.error(error);
            props.toast.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong while sending email.' });
            return false;
        }
    };

    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw', maxWidth: '800px' }}
                header={<div className="flex align-items-center justify-content-between">
                    <span className="text-xl font-bold">{isInvoice ? "Invoice" : "Itinerary"}</span>
                    <span className="text-xl font-bold">{props.singleData.contactName} | {props.singleData.contactContact}</span>
                    <Button style={{ width: '100px', marginRight: '10px' }} label={isInvoice ? "Itinerary" : "Invoice"} onClick={() => setIsInvoice(prev => !prev)} icon={`pi pi-${isInvoice ? 'bars' : 'money-bill'}`} className='p-button-info p-button-text' ></Button>
                </div>}
                footer={
                    leadReqs ? isInvoice ?
                        <div>Invoice_{props.singleData.contactName}_{props.singleData.contactContact}.pdf
                            <PDFDownloadLink document={<InvoiceDocument lead={props.singleData} reqs={leadReqs} />} fileName={`Invoice_${props.singleData.contactName}_${props.singleData.contactContact}.pdf`}>
                                <Button icon="pi pi-download" className='p-button-info p-button-text p-1 mx-2' ></Button>
                            </PDFDownloadLink>
                            <Button icon="pi pi-envelope" className='p-button-info p-button-text p-1 mx-2'
                                onClick={() => { confirmDelete() }}
                            />
                        </div> :
                        <div>Itinerary_{props.singleData.contactName}_{props.singleData.contactContact}.pdf
                            <PDFDownloadLink document={<NewItineraryDocument lead={props.singleData} reqs={leadReqs} />} fileName={`Itinerary_${props.singleData.contactName}_${props.singleData.contactContact}.pdf`}>
                                <Button icon="pi pi-download" className='p-button-info p-button-text p-1 mx-2' ></Button>
                            </PDFDownloadLink>
                            <Button icon="pi pi-envelope" className='p-button-info p-button-text p-1 mx-2'
                                onClick={() => { confirmDelete() }}
                            />
                        </div>

                        : 'Loading...'}
                modal className="p-fluid" onHide={onHide}>
                {leadReqs ? isInvoice ?
                    <PDFViewer width='100%' height='500px'>
                        <InvoiceDocument lead={props.singleData} reqs={leadReqs} />
                    </PDFViewer> :
                    <PDFViewer width='100%' height='500px'>
                        <NewItineraryDocument lead={props.singleData} reqs={leadReqs} />
                    </PDFViewer>
                    : <div>Loading...</div>}
            </Dialog >
            <ConfirmDialog visible={confirmVisible}
                onHide={() => {
                    if (!sending) setConfirmVisible(false);
                }} message="Are you sure you want to send this email?"
                header="Confirm Send" icon="pi pi-exclamation-triangle" acceptClassName="p-button-success"
                accept={async () => {
                    setSending(true);
                    const success = await sendItineraryEmail();
                    setSending(false);
                    if (success) {
                        setConfirmVisible(false);
                    }
                }}
                reject={() => {
                    if (!sending) {
                        setConfirmVisible(false);
                        rejectFunc();
                    }
                }}
                footer={
                    <div className="flex gap-2 justify-end">
                        <Button label="No" icon="pi pi-times" className="p-button-text" onClick={() => {
                            if (!sending) {
                                setConfirmVisible(false);
                                rejectFunc();
                            }
                        }}
                            disabled={sending}
                        />
                        <Button label="Yes" icon="pi pi-check" className="p-button-success"
                            onClick={async () => {
                                setSending(true); const success = await sendItineraryEmail();
                                setSending(false);
                                if (success) setConfirmVisible(false);
                            }}
                            loading={sending}
                        />

                    </div>
                }
            />
        </>
    );
}